import { usePage } from '@inertiajs/react'
import PulsingDots from '@/components/PulsingDots'

// Renders the controller's flash (shared prop `flash`) after a redirect.
// Nothing when there is neither a notice nor an alert. A notice that queued
// a sync (`flash.syncing`) is a line of green text ending in three pulsing
// dots rather than a box: it is a state, not a result, and the next visit
// takes it away (the team home's Resync spins until the sync lands,
// lib/live_refresh.ts).
export default function FlashBanner() {
  const { flash } = usePage().props
  if (!flash.notice && !flash.alert) return null

  return (
    <div className="mb-4 space-y-2" role="status">
      {flash.notice && flash.syncing && (
        <p className="flex items-center gap-2 py-2 text-sm font-medium text-positive">
          <span>{flash.notice.replace(/[.…]+$/, '')}</span>
          <PulsingDots />
        </p>
      )}
      {flash.notice && !flash.syncing && (
        <p className="rounded-control border border-positive/30 bg-positive-weak px-3 py-2 text-sm text-positive">
          {flash.notice}
        </p>
      )}
      {flash.alert && (
        <p className="rounded-control border border-negative/30 bg-negative-weak px-3 py-2 text-sm text-negative">
          {flash.alert}
        </p>
      )}
    </div>
  )
}
